export const subscriptRole = {
    name: 'subscript',
    alias: ['sub'],
    body: {
        type: 'myst',
        required: true,
    },
    run(data) {
        return [{ type: 'subscript', children: data.body }];
    },
};
